import { service } from '../../service/seatBeltEventResource';
const initialState = {
  LVehicles: [],
  LRoutes: [],
  LPolyline: [],
  LCards: [],
  LSeats: [],
  LBelts: [],
  drawingLoading: false,
};
export const createLayerStore = (set, get) => ({
  ...initialState,
  setDrawingLoading: (e) => set({ drawingLoading: e }),
  setLVehicles: (e) => set({ LVehicles: e }),
  setLRoutes: (e) => set({ LRoutes: e }),
  setLPolyline: (e) => set({ LPolyline: e }),
  setLCards: (e) => set({ LCards: e }),
  setLSeats: (e) => set({ LSeats: e }),
  setLBelts: (e) => set({ LBelts: e }),
  resetLayerState: () => {
    set({
      LVehicles: [],
      LRoutes: [],
      LPolyline: [],
      LCards: [],
      LSeats: [],
      LBelts: [],
    });
  },
  fetchSeatAndBelt: async (id) => {
    set({ error: '' });
    try {
      const beltSensorEvents =
        await service.getBeltSensorEventsByTransportationId(id, {});
      const loadCellEvents = await service.getLoadCellEventsByTransportationId(
        id,
        {},
      );
      console.log(beltSensorEvents.data.data, loadCellEvents.data.data);
      set({ LBelts: beltSensorEvents.data.data });
      set({ LSeats: loadCellEvents.data.data });
      if (
        beltSensorEvents.data.data.length === 0 &&
        loadCellEvents.data.data.length === 0
      ) {
        set({ error: 'Veri bulunamadı.' });
      }
    } catch (error) {
      set({ error: 'Bir hata ile karşılaşıldı, lütfen tekrar deneyiniz.' });
    } finally {
      set({ drawingLoading: false });
    }
  },
  resetAllLayerExceptOne: (key, value) => {
    set({ LVehicles: [] });
    set({ LRoutes: [] });
    set({ LPolyline: [] });
    set({ LCards: [] });
    set({ LSeats: [] });
    set({ LBelts: [] });
    set({ [key]: value });
  },
});
